import Vue from "vue";

export const UsersListPage = () =>
  import(/* webpackChunkName: "users-module" */ "@/views/users/List.vue");
export const UsersConfigurationPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/configurations/Layout.vue"
  );
export const UsersConfigurationTypesPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/configurations/UserTypes.vue"
  );
export const UserDetailSharedPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Shared.vue"
  );
export const UserDetailDashboardPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Dashboard.vue"
  );
export const UserDetailLoginsPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Logins.vue"
  );
export const UserDetailEditPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Edit.vue"
  );

export const UserDetailDocumentsPage = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Documents.vue"
  );

export const UsersDetailsComments = () =>
  import(
    /* webpackChunkName: "users-module" */ "@/views/users/details/Comments.vue"
  );

export function registerUsersModule(r: any): any {
  /* Side Menus Components */
  Vue.component("CreateUserSideMenuComponent", () =>
    import(
      /* webpackChunkName: "users-module" */ "@/views/users/side-menus/CreateUser.vue"
    )
  );
  Vue.component("DetailUserSideMenuComponent", () =>
    import(
      /* webpackChunkName: "users-module" */ "@/views/users/side-menus/DetailUser.vue"
    )
  );
  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "/users/configurations",
        component: UsersConfigurationPage,
        children: [
          {
            path: "",
            redirect: "types"
          },
          {
            path: "types",
            component: UsersConfigurationTypesPage
          }
        ]
      },
      {
        path: "users",
        component: UsersListPage
      },
      {
        path: "user/:id",
        component: UserDetailSharedPage,
        children: [
          {
            path: "",
            redirect: "dashboard"
          },
          {
            path: "edit",
            component: UserDetailEditPage
          },
          {
            path: "dashboard",
            component: UserDetailDashboardPage
          },
          {
            path: "logins",
            component: UserDetailLoginsPage
          },
          {
            path: "documents",
            component: UserDetailDocumentsPage
          },
          {
            name: "UsersDetailsMetadata",
            path: "details",
            component: () =>
              import(
                /* webpackChunkName: "users-module" */ "@/views/users/details/Metadata.vue"
              )
          },
          {
            name: "UsersDetailsComments",
            path: "comments",
            component: () =>
              import(
                /* webpackChunkName: "users-module" */ "@/views/users/details/Comments.vue"
              )
          },
          {
            name: "UserLogs",
            path: "Logs",
            component: () =>
              import(
                "@/views/users/details/Logs.vue"
              )
          }
        ]
      }
    );
  }
  return r;
}
